export const toIdDictionary = (models: { id: number | string }[]) => {
  return models.reduce((dictionary, model) => {
    return { ...dictionary, [model.id]: model }
  }, {})
}
